import React, { Component } from 'react';
import { connect } from "react-redux";
import Swal from 'sweetalert2';


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class WelcomeSettings extends Component {

    constructor(props) {
        super(props);

    }

    componentWillUnmount() {
        Swal.close();
    }




    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className="hv-setting-item-container">
                    <div className="language-settings-input-container">


                    <div className="language-settings-input">
                        <label>Top bar</label>
                        <div>
                            <input type="text" onChange={evt => this.props.setTopBar(evt)} value={this.props.topBar} />
                        </div>
                    </div>
                    <div className="language-settings-input">
                        <label>Welcome message</label>
                        <div>
                            <input type="text" onChange={evt => this.props.setWelcomeMessage(evt)} value={this.props.welcomeMessage}  />
                        </div>
                    </div>
                    <div className="language-settings-input">
                        <label>Message placeholder</label>
                        <div>
                            <input type="text" onChange={evt => this.props.setMessagePlaceholder(evt)} value={this.props.messagePlaceholder} />
                        </div>
                    </div>
                    </div>

                </div>
            </React.Fragment>
        );
    }
}

export default WelcomeSettings;
